import type { ReactNode } from "react";
import { motion } from "motion/react";
import { easeSoft, viewportOnce } from "../lib/motion";

export default function Section({
  eyebrow,
  title,
  description,
  children,
  className = "",
}: {
  eyebrow?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`py-8 md:py-12 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {(eyebrow || title || description) && (
          <motion.header
            className="mb-6 max-w-3xl"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ duration: 0.5, ease: easeSoft }}
          >
            {eyebrow && (
              <p className="text-lg md:text-xl font-bold uppercase tracking-wide text-sage mb-2">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-ink">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-3 text-lg text-ink-soft leading-relaxed">
                {description}
              </p>
            )}
          </motion.header>
        )}
        {children}
      </div>
    </section>
  );
}
